import React, {useEffect} from 'react';
import {Card, CardBody, CardTitle,} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import {confirmAlert} from 'react-confirm-alert';
import {connect} from "react-redux";


// components
import TranslateButton from "../../../components/buttons/TranslateButton";
import ConfirmDeleteForm from "../../../components/confirmAlertForms/ConfirmDeleteForm";
import {ActiveFormatter} from "../../../components/tables/activeFormater";

// labels
import {LIST, NO_DATA_FOUND,} from "../../../components/i18n/i18n";

// actions
import {ButtonTableDelete, ButtonTableEdit} from "../../../components/buttons/buttonsActions";
import {setFilter, setTableParams} from "../../../redux/actions/generalActions/listActions";
import {setLoading, setViewMode} from "../../../redux/actions/generalActions/mainActions";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {remove, search} from "../../../redux/actions/promo/benefitActions";

// service
import {benefitService} from "../../../jwt/_services/promotions/benefitService";

const BenefitList = (props) => {
    const { pageSize, pageIndex, totalSize, listDomainObjects, filter } = props.listProps

    useEffect(() => {
        refreshDataList(pageIndex, pageSize, filter);
    }, [pageIndex, pageSize, filter]);

    const refreshDataList =  (_pageIndex, _pageSize, _filter) => props.search(_pageIndex, _pageSize, _filter)

    const handleTableChange = (type, tableChangeParams) => {
        let currentIndex = (tableChangeParams.page - 1) * tableChangeParams.sizePerPage;
        props.setTableParams( tableChangeParams.sizePerPage, currentIndex );
    };

    const confirmDelete = (data) => {
        return confirmAlert({
            closeOnEscape: true,
            closeOnClickOutside: true,
            customUI: ({onClose}) => <ConfirmDeleteForm
                onClose={onClose}
                data={data}
                deleteItem={ data => props.remove(data?.id) }
            />
        });
    };

    const editItem = (data) => {
        props.setItem(data);
        props.setForm(true, false, false);
        props.setViewMode('FORM');
    }

    const activeFormatter = (cell) => {
        return (
            <ActiveFormatter active={cell}/>
        );
    }

    const actionsFormatter = (cell, row) => <>
        <ButtonTableEdit onClick={() => editItem(row)}/>
        <TranslateButton item={row} service={benefitService} />
        <ButtonTableDelete onClick={() => confirmDelete(row)}/>
    </>

    const columns = [{
        dataField: 'id',
        headerStyle: {width: '0px'},
        text: 'ID',
        hidden: true
    }, {
        dataField: 'uid',
        text: 'uid',
        sort: true
    }, {
        dataField: 'icon',
        text: 'Icono'
    }, {
        dataField: 'code',
        text: 'Codigo'
    }, {
        dataField: 'status',
        text: "Activo",
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '50px'},
        formatter: activeFormatter
    }, {
        dataField: 'actions',
        isDummyField: true,
        text: 'Acción',
        headerAlign: 'center',
        align: 'center',
        headerStyle: {width: '200px'},
        formatter: actionsFormatter
    }];

    return (
        <div>
            <Card>
                <CardTitle className="bg-light border-bottom p-3 mb-0">
                    <i className="far fa-list-alt mr-2"> </i>{LIST}
                </CardTitle>
                <CardBody className="">
                    <BootstrapTable
                        striped hover
                        tableHeaderClass='mb-0'
                        remote
                        keyField="id"
                        data={listDomainObjects || []}
                        columns={columns}
                        noDataIndication={NO_DATA_FOUND}
                        pagination={paginationFactory({pageIndex, pageSize, totalSize})}
                        onTableChange={handleTableChange}
                    />
                </CardBody>
            </Card>
        </div>
    )
}

const mapStateToProps = state => ({
    mainProps : state.mainProps,
    listProps : state.listProps,
})

const mapActionsToProps = ({
    setFilter,
    setTableParams,
    setViewMode,
    setForm,
    setItem,
    search,
    remove,
    setLoading,
})
export default connect(mapStateToProps, mapActionsToProps)(BenefitList)
